import { DataItem, connect } from 'scrivito'

import { AvatarGroup } from '@/Atomic/Molecules/AvatarGroup'
import { ActivityContactRelation } from '@/Data/ActivityContactRelation/ActivityContactRelationDataClass'
import { DataClassName } from '@/Data/const'
import { Person } from '@/Data/Person/PersonDataClass'
import { getDataItem } from '@/utils/getDataItem'
import { isString } from '@/utils/isString'

interface ActivityPersonAvatarGroupProps {
  activity: DataItem
  className?: string
}

/**
 * Resolves the people related to an activity and renders them as an avatar
 * group. Company relations are deliberately excluded from activity cards.
 */
export const ActivityPersonAvatarGroup: React.FC<ActivityPersonAvatarGroupProps> =
  connect(({ activity, className }) => {
    const relations = ActivityContactRelation.all()
      .transform({
        filters: {
          activity: activity.id(),
          contactEntity: DataClassName.PERSON,
        },
        limit: 100,
      })
      .take()

    const seenPersonIds = new Set<string>()
    const people = relations.flatMap((relation) => {
      if (relation.get('contactEntity') !== DataClassName.PERSON) return []

      const personId = relation.get('contact')
      if (!isString(personId) || seenPersonIds.has(personId)) return []

      const { dataItem: person } = getDataItem(Person, personId)
      if (!person) return []

      seenPersonIds.add(personId)
      return [person]
    })

    return <AvatarGroup className={className} dataItems={people} />
  })
